/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ApplicationDashboardDataQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  clientApplicationId: Types.Scalars['UUID']['input'];
}>;


export type ApplicationDashboardDataQuery = { __typename: 'Query', clientApplication?: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string } | null }, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', stats: { __typename: 'ResourceGroupStatsType', totalEmployees: number, totalNotifications: number, totalSessions: number, applicationCount: number, lastSessionTime?: string | null, totalEmployeesAuthenticated: number }, primaryApplication?: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null } } | null } | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ApplicationDashboardDataDocument = new TypedDocumentString(`
    query ApplicationDashboardData($clientId: UUID!, $clientApplicationId: UUID!) {
  clientApplication(id: $clientApplicationId, clientId: $clientId) {
    id
    resource {
      id
      productName
      resourceGroup {
        id
      }
    }
    resourceGroupApplications {
      stats {
        totalEmployees
        totalNotifications
        totalSessions
        applicationCount
        lastSessionTime
        totalEmployeesAuthenticated
      }
      primaryApplication {
        id
        resource {
          id
          productName
        }
      }
    }
  }
}
    `);

export const useApplicationDashboardDataQuery = <
      TData = ApplicationDashboardDataQuery,
      TError = unknown
    >(
      variables: ApplicationDashboardDataQueryVariables,
      options?: Omit<UseQueryOptions<ApplicationDashboardDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApplicationDashboardDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApplicationDashboardDataQuery, TError, TData>(
      {
    queryKey: ['ApplicationDashboardData', variables],
    queryFn: fetcher<ApplicationDashboardDataQuery, ApplicationDashboardDataQueryVariables>(ApplicationDashboardDataDocument, variables),
    ...options
  }
    )};

useApplicationDashboardDataQuery.getKey = (variables: ApplicationDashboardDataQueryVariables) => ['ApplicationDashboardData', variables];

export const useInfiniteApplicationDashboardDataQuery = <
      TData = InfiniteData<ApplicationDashboardDataQuery>,
      TError = unknown
    >(
      variables: ApplicationDashboardDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApplicationDashboardDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApplicationDashboardDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApplicationDashboardDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ApplicationDashboardData.infinite', variables],
      queryFn: (metaData) => fetcher<ApplicationDashboardDataQuery, ApplicationDashboardDataQueryVariables>(ApplicationDashboardDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteApplicationDashboardDataQuery.getKey = (variables: ApplicationDashboardDataQueryVariables) => ['ApplicationDashboardData.infinite', variables];


useApplicationDashboardDataQuery.fetcher = (variables: ApplicationDashboardDataQueryVariables) => fetcher<ApplicationDashboardDataQuery, ApplicationDashboardDataQueryVariables>(ApplicationDashboardDataDocument, variables);
